import { render, staticRenderFns } from "./BookingApprovalDialog.vue?vue&type=template&id=5fc6a10f&"
import script from "./BookingApprovalDialog.vue?vue&type=script&lang=js&"
export * from "./BookingApprovalDialog.vue?vue&type=script&lang=js&"
import style0 from "./BookingApprovalDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports